import styled from 'styled-components';

export const ToolbarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ActionsButtonWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
